import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LotusMark } from "./LotusMark";

const links = [
  { label: "The Story", id: "story" },
  { label: "Contact", id: "contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 2.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0a0908]/80 backdrop-blur-md border-b border-[var(--gt-line)]" : ""
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("top")}
          className="flex items-center gap-3"
        >
          <LotusMark size={30} />
          <span className="font-serif text-lg tracking-wide text-[var(--gt-ivory)]">
            The Golden Touch
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-12">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="gt-link gt-eyebrow hover:text-[var(--gt-ivory)] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a
            href="tel:2109989393"
            data-testid="nav-phone"
            className="gt-eyebrow gt-gold-text"
          >
            210 · 998 · 9393
          </a>
        </nav>

        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden gt-eyebrow text-[var(--gt-ivory)]"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-[#0a0908] border-b border-[var(--gt-line)]"
          >
            <div className="px-6 py-8 flex flex-col gap-6">
              {links.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-left font-serif text-2xl text-[var(--gt-ivory)]"
                >
                  {l.label}
                </button>
              ))}
              <a href="tel:2109989393" className="gt-gold-text font-serif text-2xl">
                210 · 998 · 9393
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
